export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.21-1448.05",
  commitId: "6d6a4d6321dce990d3ae3cf71b0e6239c195ec54",
  commitTime: "2026-07-21T14:48:05.000Z",
});
